export default __webpack_public_path__ + "static/media/_fonts.b572ec3f.css";